var _style, _g, _g2, _g3, _g4, _g5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgXp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 250 250",
    style: {
      enableBackground: "new 0 0 250 250"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{enable-background:new    ;}\r\n\t.st1{fill:#009382;}\r\n\t.st2{fill:#FFFFFF;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "O_00000167362943539501153230000008939784838597734582_",
    className: "st0"
  }, /*#__PURE__*/React.createElement("g", {
    id: "O"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.7071 -0.7071 0.7071 0.7071 -51.8147 125.0917)",
    className: "st1",
    cx: 125.1,
    cy: 125.1,
    rx: 123.5,
    ry: 123.5
  }))))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "W_00000013158311054745835970000010708888301039710340_",
    className: "st0"
  }, /*#__PURE__*/React.createElement("g", {
    id: "W"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.7071 -0.7071 0.7071 0.7071 -51.8149 125.0921)",
    className: "st2",
    cx: 125.1,
    cy: 125.1,
    rx: 118.2,
    ry: 118.2
  }))))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "O_00000170978209405840823640000010966614961644241563_",
    className: "st0"
  }, /*#__PURE__*/React.createElement("g", {
    id: "O_00000124155813165556953820000009564168648270399633_"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 125.1,
    cy: 125.1,
    r: 103.4
  }))))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "W_00000041254450185222903780000005207290509492380313_",
    className: "st0"
  }, /*#__PURE__*/React.createElement("g", {
    id: "W_00000062159812724140310970000013898261145862835587_"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "st2",
    cx: 125.1,
    cy: 125.1,
    r: 97.1
  }))))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "XP_00000104678237900971330210000015089154931216628870_",
    className: "st0"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XP"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M123.6,150.5c-1.3-3.2-2.6-6.4-3.9-9.5c-1.3-3.1-2.3-5.8-3.2-7.9c-0.3-1.4-0.9-2.5-1.8-3.5 c-0.9-1-2.1-1.8-3.4-2.5c-1.4-0.7-2.9-1.2-4.5-1.5c-1.7-0.3-3.4-0.5-5.2-0.5v-1.6c3.8-0.1,7-0.7,9.7-1.8c2.7-1,4.4-2.8,5.3-5.4 c2.1-5.5,4.3-10.9,6.6-16.2c2.3-5.2,4.3-10.5,6.2-15.8h-28.5l-11.7,33.4h-2.6L74.7,84.4H46.2c1.9,5.2,4,10.5,6.3,15.9 c2.3,5.4,4.5,10.8,6.6,16.2c0.4,1.2,1,2.2,2,3.1c1,0.9,2.1,1.6,3.5,2.1c1.4,0.6,2.8,1,4.4,1.3c1.6,0.3,3.3,0.4,5,0.4v1.7 c-1.6,0-3.3,0.2-4.9,0.6c-1.6,0.4-3.1,0.9-4.5,1.5c-1.4,0.6-2.5,1.4-3.4,2.2c-0.9,0.8-1.6,1.7-1.9,2.5c-2.3,5.8-4.6,11.5-7,17.2 c-2.4,5.7-4.6,11.3-6.6,16.6h28.5l12.5-33.6h2.6l12.3,33.6H130c-0.6-1.4-1.5-3.5-2.7-6.3C126.2,156.7,125,153.7,123.6,150.5z  M202.8,91.6c-5.8-4.8-14.2-7.2-25.3-7.2h-41.1c0.1,6.3,0.1,12.9,0.2,19.6c0,6.7,0.1,13.7,0.1,21.1c0,7.4,0,14.5-0.1,21.2 c0,6.7-0.1,13.3-0.2,19.6h26.5c-0.1-0.9-0.1-2.3-0.2-4.1c0-1.8-0.1-3.7-0.1-5.7c0-2-0.1-4.1-0.1-6.1c0-2.1,0-3.8,0-5.3 c0-1.8-0.1-3.6-0.3-5.2c-0.2-1.6-0.5-3.3-1-5.2l1.5-0.3c0.8,2.6,1.8,5,3,7.1c1.2,2.1,3.2,3.6,5.9,4.4c1.2,0.6,2.8,1,4.9,1.2 s4.8,0.3,8.3,0.3c4.8,0,8.9-0.6,12.3-1.8c3.4-1.2,6.1-3.1,8.3-5.7c2.1-2.6,3.7-5.9,4.6-10c1-4.1,1.4-8.9,1.4-14.5 C211.4,104.2,208.5,96.4,202.8,91.6z M183.8,123.2c-0.6,1.9-1.5,3.4-2.6,4.5c-1.1,1.1-2.4,1.9-3.9,2.4c-1.5,0.5-3.1,0.7-4.9,0.7 h-10v-28.7h9.7c3.9,0,7,1,9.2,3c2.2,2,3.4,5.7,3.4,11.1C184.7,119,184.4,121.3,183.8,123.2z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgXp);
export default __webpack_public_path__ + "static/media/xp.7a384c0a8b3d4222c22e2b8e7953d0a6.svg";
export { ForwardRef as ReactComponent };